import React, { useEffect, useRef, useState } from "react";
import TextField from "@mui/material/TextField";
import { toast } from "react-toastify";
import MobileNumberFieldWithCountryCode from "../CommonComponent/MobileNumberFieldWithCountryCode";

const AdminDetails = ({
  isNextClicked,
  setActiveStep,
  setIsNextClicked,
  setAllData,
  allData,
}) => {
  const [isError, setIsError] = useState();
  const [formData, setFormData] = useState({
    adminName: "",
    adminEmail: "",
    adminMoNumber: "",
    adminPhoto: "",
    adminPhotoName: "",
    adminCountryCode: "+91",
  });
  const adminPhotoInputRef = useRef();

  useEffect(() => {
    // setFormData({ ...allData.adminDetails });
    setFormData({
      adminCountryCode: "+91", // Ensure default is set here too
      ...allData.adminDetails,
    });
  }, []);

  useEffect(() => {
    if (isNextClicked) {
      Object.keys(formData).map((val, i) => {
        if (!String(formData[val])) {
          setIsError(true);
          setIsNextClicked(false);
          return;
        } else if (i === Object.keys(formData).length - 1) {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setAllData((prev) => ({ ...prev, adminDetails: formData }));
        }
      });
      setIsNextClicked(false);
    }
  }, [isNextClicked]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleMobileNumberChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      adminMoNumber: e.target.value,
    }));
  };

  const handleCountryCodeChange = (code) => {
    setFormData((prev) => ({
      ...prev,
      adminCountryCode: `+${code}`,
    }));
  };

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const adminPhotoChangeHandler = async (e) => {
    const file = e.target.files[0];

    if (!file) return;
    const fileExtension = file.name.split(".").pop().toLowerCase();
    const formDataUpload = new FormData();
    formDataUpload.append("file", file);
    formDataUpload.append("fileName", file.name);
    formDataUpload.append("folderName", "admin");
    formDataUpload.append("uniqueID", formData.adminEmail);
    formDataUpload.append("documentID", "logo");
    formDataUpload.append("fileExtension", fileExtension);

    try {
      // const response = await fetch("http://localhost:4001/documentfileupload", {
      const response = await fetch(
        "https://littleinfinity.in:4001/documentfileupload",
        {
          method: "POST",
          body: formDataUpload,
        }
      );

      const data = await response.json();

      if (response.ok) {
        setFormData((prev) => ({
          ...prev,
          adminPhoto: data?.data, // Store the file URL
          adminPhotoName: file.name, // Store file name
        }));
        // setSnackbarMessage("Logo uploaded successfully!");
        // alert("Photo uploaded successfully!");
        toast.success("Photo uploaded successfully!");
      } else {
        console.error("Error in upload:", data.message);
        toast.error("Something went wrong!");

        // setSnackbarMessage("Error uploading logo: " + data.message);
      }
    } catch (error) {
      console.error("Error uploading logo:", error);
      // setSnackbarMessage("Error uploading logo!");
    } finally {
      // setIsUploading(false);
      // setSnackbarOpen(true);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignSelf: "flex-start",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        gap: "35px",
        padding: "10px",
      }}
    >
      <TextField
        id="standard-basic"
        value={formData.adminName}
        name="adminName"
        onChange={handleInputChange}
        label="Name"
        variant="standard"
        sx={{ width: "250px" }}
      />
      <TextField
        id="standard-basic"
        value={formData.adminEmail}
        name="adminEmail"
        onChange={handleInputChange}
        label="Emaild"
        variant="standard"
        sx={{ width: "250px" }}
      />
      <MobileNumberFieldWithCountryCode
        value={formData.adminMoNumber}
        onChange={handleMobileNumberChange}
        onCountryCodeChange={handleCountryCodeChange}
        label="Mobile No."
        variant="standard"
        defaultCountryCode={formData.adminCountryCode || "+91"}
        sx={{ width: "250px" }}
      />
      <TextField
        id="standard-basic"
        value={formData.adminPhotoName}
        // name= " adminPhoto"
        onClick={() => adminPhotoInputRef.current.click()}
        label="Photo"
        variant="standard"
        sx={{ width: "250px" }}
      />
      <input
        type="file"
        style={{ display: "none" }}
        onChange={adminPhotoChangeHandler}
        ref={adminPhotoInputRef}
      />
    </div>
  );
};

export default AdminDetails;
